import React from 'react';

import { getCart, selectCartStatus } from '@entities/cart';
import { useModules } from '@entities/common/modules';

import { useUser } from '@shared/hooks';
import { useAppDispatch, useAppSelector } from '@shared/hooks';

export const useLoadCart = () => {
	const dispatch = useAppDispatch();
	const { isAuth } = useUser();

	const { modules } = useModules();
	const cartStatus = useAppSelector(selectCartStatus);

	React.useEffect(() => {
		// проверяем авторизацию и подключение магазина
		if (isAuth) {
			if (
				modules?.filter((appModule) => appModule.code === 'store').length !== 0 &&
				cartStatus === 'idle'
			) {
				dispatch(getCart());
			}
		}
	}, [isAuth, dispatch, modules, cartStatus]);

	return {};
};
